import axios from "axios";

export async function uploadFileToPresignedUrl(
	uploadUrl: string,
	file: File | Blob,
	contentType: string
): Promise<void> {
	await axios.put(uploadUrl, file, {
		headers: { "Content-Type": contentType },
	});
}
